<template lang="html">
   <transition name="slide-fade">
      <div class="ap-modal" v-show="showModal">
         <div class="overlay">
            <div class="row justify-content-end">
               <div class="ap-modal-content" :class="content_class" @keyup.esc="closeModal()" tabindex="0">
                  <div class="clearfix">
                     <div class="close-box" @click="closeModal()">
                        <i class="fa fa-times r"></i> 
                        <div class="l">Close</div>
                     </div>
                  </div>
                  <div class="title-box-modal" v-if="show_header">
                     <slot name="title"></slot>
                  </div>
                  <div class="scroll-content">
                     <scrollbar>
                        <slot name="content"></slot>
                     </scrollbar>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </transition>
</template>

<script>
import VueScrollbar from 'vue-scrollbar-simple';

export default {
   props:{
      show: {
         type: [Boolean, Number],
         default: false
      },
      show_header: {
         type: [Boolean, Number],
         default: true
      },
      content_class:{
         type: String,
         default: ''
      }
   },
   components:{
      scrollbar: VueScrollbar
   },
   watch: {
      show(){
         this.showModal = this.show
      },
   },
   data () {
      return {
         showModal: this.show,
         isLoading: this.loading
      }
   },
   methods:{
      closeModal(){
         this.$emit('close',true)
      }
   }
}
</script>

<style lang="scss">
   .ap-modal{
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 2000;
      // overflow-y: scroll;

      .scroll-content{
         height: calc(100vh - 150px);
      }
      .overlay{
         background: rgba($nav-side-color,.4);
         height: 100%;
         width: 100%;

         .row{
            height: 100%;
         }
         .ap-modal-content{
            padding: 20px;
            height: 100%;
            background: $white;
            border-left: solid 1px hsl(0, 0%, 80%);

            .title-box-modal{
               padding: 15px 20px;
               margin: 20px -20px !important;
               background: #F4F4F4;

               .title{
                  font-size: 15px;
                  font-weight: 600;
                  line-height: 13px;
               }
            }
            .close-box{
               font-weight: 600;
               cursor: pointer;
               float: right;

               .fa{
                  padding: 2px 0 0 15px !important;
                  font-size: 15px;
               }
            }
            .close-box:hover{
               color: $color-two;
            }
         }
      }
   }
</style>